import { useQuery } from 'react-query'

import { tfaService } from '@/modules/profile-settings/service/tfa-service.tsx'

export function useTfaQRCode() {
  return useQuery('tfa-generate-qr-code', tfaService.generateQRCode)
}
